import {
    RadialBarChart,
    RadialBar,
    PolarAngleAxis
} from 'recharts';

const getColor = (value, max) => {

    const percent = value / max;

    if (percent < 0.4)
        return '#ef4444';

    if (percent < 0.7)
        return '#f59e0b';

    return '#22c55e';
};

const ScoreGauge = ({
    value = 0,
    max = 100,
    title = 'امتیاز',
    width = 220,
    height = 220,
    thickness = 18,
    color
}) => {

    const percent = Math.min(value / max, 1);

    const data = [
        {
            value: percent * 100
        }
    ];

    const gaugeColor = color || getColor(value, max);

    return (
        <div className='score'
            style={{
                width,
                height,
                position: 'relative',
            }}
        >

            <RadialBarChart
                width={width}
                height={height}
                innerRadius="78%"
                outerRadius="92%"
                data={data}
                startAngle={90}
                endAngle={-270}
            >

                <PolarAngleAxis
                    type="number"
                    domain={[0, 100]}
                    tick={false}
                />

                {/* Background */}

                <RadialBar
                    data={[{ value: 100 }]}
                    dataKey="value"
                    fill="#ECECEC"
                    cornerRadius={thickness}
                    isAnimationActive={false}
                />

                {/* Value */}

                <RadialBar
                    dataKey="value"
                    fill={gaugeColor}
                    cornerRadius={thickness}
                    animationDuration={1200}
                />

            </RadialBarChart>

            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >

                <div
                    style={{
                        fontSize: 14,
                        color: '#777',
                        marginBottom: 8
                    }}
                >
                    {title}
                </div>

                <div
                    style={{
                        fontSize: 35,
                        fontWeight: 700,
                        color: gaugeColor,
                        lineHeight: 1
                    }}
                >
                    {value}
                </div>

                <div
                    style={{
                        marginTop: 10,
                        fontSize: 15,
                    }}
                >
                    از {max}
                </div>

            </div>

        </div>
    );

};

export default ScoreGauge;